import { render, staticRenderFns } from "./ModalImagePreview.vue?vue&type=template&id=487cacf2&scoped=true&"
import script from "./ModalImagePreview.vue?vue&type=script&lang=js&"
export * from "./ModalImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ModalImagePreview.vue?vue&type=style&index=0&id=487cacf2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cacf2",
  null
  
)

export default component.exports